import React, { useRef, useEffect } from 'react';
import './issue-invoice-list.scss';
import DynamicInputList from '../software-dynamic-version-5/list-input-v-5';
import IssueInvoiceAdd from './issue-invoice-add';
import IssueInvoiceService from './issue-invoice.service';
import moment from 'moment';
import securityService from '../security/security.service';
import './issue-invoice-list.scss';

const IssueInvoiceList = (props) => {
  let columns = [
    { field: "InvoiceIssueID", headerText: 'Issue Invoice ID', width: '160px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    // { field: "CompanyID", headerText: 'Company ID', width: '120px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "InvoiceIssueDate", headerText: 'Issue Invoice Date', width: '160px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    // { field: "CostCenterID", headerText: 'Cost Center ID', width: '120px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "AccountTitleExpense", headerText: 'Account Title Expense', width: '160px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    // { field: "AccountIDExpense", headerText: 'Account ID Expense', width: '120px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "ByIssued", headerText: 'Issued By', width: '120px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "TotalIssueQuantity", headerText: 'Total Issue Quantity', width: '120px', textAlign: 'right', headerTextAlign: 'center', other:[{format:'n2'}] },
  ];

  const listActionComplete = (grid, args, getListService, selectedRow) => {
    console.log("args", args);
    console.log("getListService", getListService);
    console.log("selectedRow", selectedRow);
    if (args.requestType === 'beginEdit' || args.requestType === 'add') {
      // handle beginEdit or add if needed
    }
    if (args.requestType === 'save' || args.requestType === 'cancel') {
      setTimeout(() => { getListService(); }, 560);
    }
    if (args.requestType === 'save' && args.data.IssueInvoiceID) {
      let data = {
        IssueInvoiceID: args.data.IssueInvoiceID,
        CompanyID: args.data.CompanyID,
        IssueInvoiceDate: moment(args.data.IssueInvoiceDate).format('DD-MMM-YY'),
        CostCenterID: args.data.CostCenterID,
        AccountTitleExpense: args.data.AccountTitleExpense,
        AccountIDExpense: args.data.AccountIDExpense,
        IssuedBy: args.data.IssuedBy,
        TenantContractFSID: args.data.TenantContractFSID,
        TotalIssueQuantity: args.data.TotalIssueQuantity
      };
      IssueInvoiceService.editIssueInvoice(data).then((res) => {
        console.log(res);
        // setTimeout(()=>{getListService()},560)
      });
    }
  };

  let allowTemplate = false;
  let allowDataBound = false;
  let isDialog = props.IsDialog == true ? true : false;
  let allowGridSum = true;
  let ListSecurity = 'Issue Invoice';
  let AddSecurity = 'Issue Invoice';
  let EditSecurity = 'Issue Invoice';
  let DeleteSecurity = 'Issue Invoice';

  let toolbarOptions = 'All';
  const toolbarClicking = async (args) => {
    console.log(args);
  };
  let DefaultSortedColumnSort = 'Descending';
  let listDelete = [{ TableName: ['IssueInvoice_Detail', 'IssueInvoice'], TableID: ['IssueInvoiceID'] }];
  let deleteType = 'Hard';
  let filterColumns = [];
  let groupColumns = [];
  let gridEditSettingMode = 'Dialog';
  let gridEditSettingHeaderTemplate = '<p></p>';
  let gridSumColumns = ['TotalAmount'];

  const getIssueInvoiceForList = async () => {
    return IssueInvoiceService.getForList();
  };

  return (
    <DynamicInputList
      Id='IssueInvoice'
      ListTitle={`Issue Invoice - LIST`}
      ColumnsList={columns}
      GridDataSource={[
        {
          DataSourceType: 'Function',
          DataSource: () => getIssueInvoiceForList()
        }
      ]}
      DefaultSortedColumnName={'InvoiceIssueID'}
      GridDialog={[
        {
          DialogType: 'Self',
          Dialog: <IssueInvoiceAdd GridID={`IssueInvoice`} />
        }
      ]}
      ListActionComplete={listActionComplete}
      ToolbarClicking={toolbarClicking}
      AllowTemplate={allowTemplate}
      ToolbarOption={toolbarOptions}
      AllowDataBound={allowDataBound}
      ListSecurity={ListSecurity}
      AddSecurity={AddSecurity}
      EditSecurity={EditSecurity}
      DeleteSecurity={DeleteSecurity}
      DefaultSortedColumnSort={DefaultSortedColumnSort}
      FilterColumns={filterColumns}
      ListDelete={listDelete}
      DeleteType={deleteType}
      GridEditSettingMode={gridEditSettingMode}
      GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
      // GridSumColumns={gridSumColumns}
      AllowGridSum={allowGridSum}
      IsDialog={isDialog}
      // ...other props as in export-sale-invoice-list.js
    />
  );
};

export default IssueInvoiceList;
